import React from 'react';
import { Button } from 'antd';
import { SparkleIcon, LightningIcon } from '@phosphor-icons/react';
import { DashboardRunAiBlockedStatus } from './DashboardRunAiBlockedStatus';

export interface DashboardAiRailAiEmptyStateProps {
    handleRunAi?: () => void;
    aiLoading: boolean;
    runAiReady: boolean;
    runAiBlockedStatus?: string | null;
    /** When a saved design is on the roof but AI catalog has not been generated yet. */
    selectedSavedDesignLabel?: string | null;
    /** Inside the scenarios block (module bar above); drop duplicate card chrome and CTA. */
    embedded?: boolean;
}

export function DashboardAiRailAiEmptyState({
    handleRunAi,
    aiLoading,
    runAiReady,
    runAiBlockedStatus = null,
    selectedSavedDesignLabel = null,
    embedded = false,
}: DashboardAiRailAiEmptyStateProps) {
    const hasSavedDesign = Boolean(selectedSavedDesignLabel?.trim());
    const emptyClassName = embedded
        ? 'obd-ai-rail__empty obd-ai-rail__empty--embedded'
        : 'obd-ai-rail__empty';

    return (
        <div className={emptyClassName}>
            <span className="obd-ai-rail__empty-sparkle" aria-hidden>
                <SparkleIcon size={40} weight="duotone" />
            </span>
            {hasSavedDesign ? (
                <>
                    <p className="obd-ai-rail__empty-title">Saved design loaded</p>
                    <p className="obd-ai-rail__empty-copy">
                        <strong>{selectedSavedDesignLabel}</strong> is on the roof. Press{' '}
                        <strong>Run AI Design</strong> in the toolbar to generate layout stats and category options.
                    </p>
                </>
            ) : (
                <p className="obd-ai-rail__empty-copy">
                    Press <strong>Run AI Design</strong> to generate layout options here.
                </p>
            )}
            {!embedded ? (
                <div className="obd-ai-rail__empty-actions">
                    <Button
                        size="small"
                        type="default"
                        onClick={() => {
                            if (typeof handleRunAi === 'function') handleRunAi();
                        }}
                        loading={aiLoading}
                        disabled={!runAiReady || aiLoading}
                        className="obd-ai-rail__cta obd-ai-rail__cta--primary"
                    >
                        <span className="obd-ai-rail__cta-content">
                            <span className="obd-ai-rail__cta-icon-slot">
                                <LightningIcon
                                    size={16}
                                    weight="fill"
                                    className="obd-ai-rail__cta-icon obd-ai-rail__cta-icon--run"
                                />
                            </span>
                            <span>Run AI Design</span>
                        </span>
                    </Button>
                </div>
            ) : null}
            <DashboardRunAiBlockedStatus message={runAiBlockedStatus} />
        </div>
    );
}
